import {AfterViewInit, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Data} from "@angular/router";
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {ReportStore} from '../../../shared/store/report/report.store';
import {ReportChartStore} from '../../../shared/store/report/report-chart.store';
import {AdRequestParams} from '../../../shared/interfaces/ad-reports';
import {PublicReportData} from '../../../shared/store/publicReports/public-reports';
import {ReportParamsStore} from '../../../shared/store/report/report-params.store';
import {ReportsRequestsService} from "../../../shared/services/reports-requests.service";
import {ReportsChartService} from "../../../shared/services/reports-chart.service";
import {ColorsService} from "../../../shared/services/colors.service";

@Component({
  selector: 'app-chart-report',
  templateUrl: './chart-report.component.html',
  styleUrls: ['./chart-report.component.scss'],
  providers: [
    ReportStore,
    ReportParamsStore,
    ReportChartStore,
    ReportsRequestsService,
    ReportsChartService,
    ColorsService
  ]
})
export class ChartReportComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input('publicReportData') set setReport(publicReportData: PublicReportData | null | undefined) {
    if (publicReportData) {
      this._reportStore.initPublicReport(
        publicReportData.report,
        publicReportData.uuid,
        publicReportData.token
      );
    }
  };

  public readonly iframe$: Observable<boolean> = this._route.data.pipe(map((data: Data): boolean => data.iframe || false));
  public readonly requestParams$: Observable<Partial<AdRequestParams> | null> = this._reportStore.requestParams$;
  public readonly initialized$: Observable<boolean> = this._reportStore.initialized$;

  constructor(
    private readonly _reportStore: ReportStore,
    private readonly _route: ActivatedRoute
  ) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {}

  ngOnDestroy(): void {}
}
